var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceDetectionSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vzhvyjbcta)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.333 2.333H3.5A1.167 1.167 0 0 0 2.333 3.5v5.833a1.167 1.167 0 1 0 2.333 0V4.667h4.667a1.167 1.167 0 0 0 0-2.334zm0 21H4.666v-4.666a1.166 1.166 0 1 0-2.333 0V24.5A1.167 1.167 0 0 0 3.5 25.667h5.833a1.167 1.167 0 1 0 0-2.334zm15.167-21h-5.834a1.167 1.167 0 0 0 0 2.334h4.667v4.666a1.167 1.167 0 1 0 2.333 0V3.5A1.167 1.167 0 0 0 24.5 2.333zm0 15.167a1.167 1.167 0 0 0-1.167 1.167v4.666h-4.667a1.167 1.167 0 1 0 0 2.334H24.5a1.167 1.167 0 0 0 1.166-1.167v-5.833A1.166 1.166 0 0 0 24.5 17.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#mgdi42f1fb)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#24E4D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1 14.167h26"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vzhvyjbcta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mgdi42f1fb",
    x: -4,
    y: 9.167,
    width: 36,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141176 0 0 0 0 0.894118 0 0 0 0 0.847059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceDetectionSelect);
export default __webpack_public_path__ + "static/media/face_detection_select.90d75499107f08f59ff38384acb6c8fd.svg";
export { ForwardRef as ReactComponent };